import React, { Component } from 'react';
import {
  Divider,
  Switch,
  Slider,
  Button,
  NumericInput,
} from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class ScheduledGifts extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      ScheduledGifts: true,
      PlayMinutesPerGift: 60,
      SilksAmount: '',
      GoldsAmount: '',
      MinLevelForGift: 60,
    };

    this.handleChange = (Name) => (Value) => {
      if (typeof this.state[Name] === 'boolean')
        this.setState({ [Name]: !this.state[Name] });
      else if (Value.target) this.setState({ [Name]: Value.target.value });
      else this.setState({ [Name]: Value });
    };
  }

  render() {
    const SwitchOnOff = { innerLabelChecked: 'on', innerLabel: 'off' };

    return (
      <SideMenuWrapper>
        <h3
          className="display-4 font-italic mb-4"
          style={{ fontSize: '1.5rem' }}
        >
          Scheduled Gifts
        </h3>

        <Divider />

        <table className="bp3-html-table bp3-html-table-bordered bp3-interactive html-table-row-border">
          <tbody>
            <tr>
              <td>Scheduled Gifts System</td>
              <td>
                <Switch
                  checked={this.state.ScheduledGifts}
                  {...SwitchOnOff}
                  onChange={this.handleChange('ScheduledGifts')}
                />
              </td>
            </tr>

            <tr>
              <td>Play Minutes per Gift</td>
              <td style={{ width: '240px' }}>
                <NumericInput
                  disabled={!this.state.ScheduledGifts}
                  style={{ width: '120px' }}
                  value={this.state.PlayMinutesPerGift}
                  placeholder="Type minutes..."
                  onValueChange={this.handleChange('PlayMinutesPerGift')}
                  min={0}
                />
              </td>
            </tr>

            <tr>
              <td>Gift Silks Amount</td>
              <td style={{ width: '240px' }}>
                <NumericInput
                  disabled={!this.state.ScheduledGifts}
                  style={{ width: '150px' }}
                  value={this.state.SilksAmount}
                  placeholder="Type silk amount..."
                  onValueChange={this.handleChange('SilksAmount')}
                  min={0}
                />
              </td>
            </tr>

            <tr>
              <td>Gift Golds Amount</td>
              <td style={{ width: '240px' }}>
                <NumericInput
                  disabled={!this.state.ScheduledGifts}
                  style={{ width: '150px' }}
                  value={this.state.GoldsAmount}
                  placeholder="Type gold amount..."
                  onValueChange={this.handleChange('GoldsAmount')}
                  min={0}
                />
              </td>
            </tr>

            <tr>
              <td>Minumum Level for Gift</td>
              <td style={{ width: '360px' }}>
                <Slider
                  disabled={!this.state.ScheduledGifts}
                  min={20}
                  max={120}
                  labelStepSize={10}
                  onChange={this.handleChange('MinLevelForGift')}
                  value={this.state.MinLevelForGift}
                  className="mb-4"
                />
              </td>
            </tr>

            <tr>
              <td></td>
              <td>
                <Button className="mt-2" icon="floppy-disk" text="Save" />
              </td>
            </tr>
          </tbody>
        </table>
      </SideMenuWrapper>
    );
  }
}
